import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgParade(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M14.285 12.38L16 14v2H8.022L8 14l1.771-1.62 1.179 2.12L12 12.561l1.05 1.939zM16.706 9l-.479 3.55-2.116-1.8-1.056 1.829L12 10.75l-1.056 1.829-1.056-1.829-2.104 1.81L7.305 9zM18 6.75c0 .908-.716 1.5-1.6 1.5H7.601C6.716 8.25 6 7.658 6 6.75zM4.095.18c.15-.203.44-.24.636-.082l3.647 2.92c.196-.122.422-.197.668-.197.82 0 1.462.791 1.24 1.673a1.29 1.29 0 01-.899.923c-.857.228-1.626-.432-1.626-1.275 0-.136.026-.265.063-.388L4.175.834a.474.474 0 01-.08-.654zm9.65.442l.143.007c.597.055.85.337 1.014.656l4.59-.586a.454.454 0 01.504.404.463.463 0 01-.393.52l-4.587.585c-.08.342-.285.66-.644.858-.4.22-.91.204-1.29-.052a1.345 1.345 0 01-.228-2.04c.268-.28.654-.38 1.034-.345z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Parade')(SvgParade);
